import React from 'react';
import PropTypes from 'prop-types';

import {Accordion, AccordionSummary, AccordionDetails, Box, Button} from 'views/components';
import {Stack, Typography} from 'views/components';
import {Translate, translate, ReactToPrint} from 'views/module';

import SlipHourOverview from './SlipHourOverview';
import SlipHourDetails from './SlipHourDetails';

import moment from 'moment';

const SlipView = (props) => {
  const [isExpanded, setIsExpanded] = React.useState(false);
  const [isCompleting, setIsCompleting] = React.useState(false);
  const printableRef = React.useRef(null);

  const {slipDetail, caregiverBackend, caregiverPaymentPlan} = props;
  const {weekOf, status} = slipDetail;

  const weekOfDisplay = moment(weekOf, 'YYYY[Week]WW').format('YYYY-MM-DD');
  const handleComplete = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsCompleting(true);
    caregiverBackend.payment.markAsComplete(weekOf);
  };

  return (
    <Stack spacing={1}>
      <Accordion
        elevation={0}
        expanded={isExpanded}
        onChange={(event, isExpanded) => setIsExpanded(isExpanded)}
        sx={{width: 1}}
        disableGutters
      >
        <AccordionSummary>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            sx={{width: '100%'}}
          >
            <Typography
              sx={{
                fontWeight: 'bold',
              }}
            >
              <Translate
                expression="caregiver.CaregiverDetail.Payment.WeekOf"
                substitute={{
                  date: weekOfDisplay,
                  status: status === 'IN_PROGRESS' ?
                    translate('caregiver.CaregiverDetail.Payment.WaitingConfirmation') :
                    translate('caregiver.CaregiverDetail.Payment.Complete'),
                }}
              />
            </Typography>
            <Stack direction="row" spacing={1}>
              <ReactToPrint
                printableRef={printableRef}
                documentTitle={`PaymentSlip_${weekOfDisplay}_${slipDetail?.hours?.[0]?.caregiver?.caregiverDetail?.caregiverName}`}
              />
              {
                status === 'IN_PROGRESS' &&
                <Button onClick={handleComplete} variant="contained" loading={isCompleting}>
                  <Translate
                    expression="caregiver.CaregiverDetail.Payment.Complete"
                  />
                </Button>
              }
            </Stack>
          </Stack>
        </AccordionSummary>
        <AccordionDetails>
          {/* Printable content */}
          <Box ref={printableRef}>
            <SlipHourOverview slipDetail={slipDetail} caregiverPaymentPlan={caregiverPaymentPlan} />
            <SlipHourDetails slipDetail={slipDetail} caregiverPaymentPlan={caregiverPaymentPlan} />
          </Box>
        </AccordionDetails>
      </Accordion>
    </Stack>
  );
};

SlipView.propTypes = {
  slipDetail: PropTypes.object.isRequired,
  caregiverBackend: PropTypes.object.isRequired,
  caregiverPaymentPlan: PropTypes.object.isRequired,
};

export default React.memo(SlipView);
